import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Checkbox, Box, Heading, Text } from '@medeo/components'
import { PatientContext } from './AddPatientChannel'
import Form from '../components/AddPatientForm'
import FormFooter from '../components/AddPatientFormFooter'

const renderEligibleCriteriaFromContext = context => {
  const { disease } = context.state
  switch (disease) {
    case 'type1Diabetes':
      return (
        <ol>
          <FormattedMessage id="majorityCriterion">
            {label => (
              <li>
                <Text>{label}</Text>
              </li>
            )}
          </FormattedMessage>
          <FormattedMessage id="type1DiabetesCriterion">
            {label => (
              <li>
                <Text>{label}</Text>
              </li>
            )}
          </FormattedMessage>
        </ol>
      )
    case 'type2Diabetes1Injection':
    case 'type2DiabetesOtherSchemas':
      return (
        <ol>
          <FormattedMessage id="majorityCriterion">
            {label => (
              <li>
                <Text>{label}</Text>
              </li>
            )}
          </FormattedMessage>
          <FormattedMessage id="type2DiabetesCriterion">
            {label => (
              <li>
                <Text>{label}</Text>
              </li>
            )}
          </FormattedMessage>
        </ol>
      )
    case 'heartFailure':
      return (
        <ol>
          <FormattedMessage id="heartFailure1Criterion">
            {label => (
              <li>
                <Text>{label}</Text>
              </li>
            )}
          </FormattedMessage>
          <FormattedMessage id="heartFailure2Criterion">
            {label => (
              <li>
                <Text>{label}</Text>
              </li>
            )}
          </FormattedMessage>
        </ol>
      )
    case 'kidneyFailure':
      return (
        <ol>
          <FormattedMessage id="kidneyFailureCriterion">
            {label => (
              <li>
                <Text>{label}</Text>
              </li>
            )}
          </FormattedMessage>
        </ol>
      )
    default:
      return new Error()
  }
}
const renderNonEligibleCriteriaFromContext = context => {
  let { disease } = context.state
  switch (disease) {
    case 'type1Diabetes':
    case 'type2Diabetes1Injection':
    case 'type2DiabetesOtherSchemas':
      disease = 'diabetes'
      break
    default:
      break
  }

  return (
    <ul>
      <FormattedMessage id="abilityCriterion">
        {label => (
          <li>
            <Text>{label}</Text>
          </li>
        )}
      </FormattedMessage>
      {disease !== 'kidneyFailure'
        ? [
            <FormattedMessage key="dialysisCriterion" id="dialysisCriterion">
              {label => (
                <li>
                  <Text>{label}</Text>
                </li>
              )}
            </FormattedMessage>,
            <FormattedMessage
              key="dialysisCriterion"
              id="liverFailureCriterion"
            >
              {label => (
                <li>
                  <Text>{label}</Text>
                </li>
              )}
            </FormattedMessage>
          ]
        : [
            <FormattedMessage
              key="nonEligibilityCriterion1"
              id="nonEligibilityCriterion1"
            >
              {label => (
                <li>
                  <Text>{label}</Text>
                </li>
              )}
            </FormattedMessage>,
            <FormattedMessage
              key="nonEligibilityCriterion2"
              id="nonEligibilityCriterion2"
            >
              {label => (
                <li>
                  <Text>{label}</Text>
                </li>
              )}
            </FormattedMessage>,
            <FormattedMessage
              key="nonEligibilityCriterion3"
              id="nonEligibilityCriterion3"
            >
              {label => (
                <li>
                  <Text>{label}</Text>
                </li>
              )}
            </FormattedMessage>
          ]}
      <FormattedMessage id="pathologyCriterion" values={{ disease }}>
        {label => (
          <li>
            <Text>{label}</Text>
          </li>
        )}
      </FormattedMessage>
      <FormattedMessage id="companionCriterion">
        {label => (
          <li>
            <Text>{label}</Text>
          </li>
        )}
      </FormattedMessage>
      <FormattedMessage id="homeCriterion">
        {label => (
          <li>
            <Text>{label}</Text>
          </li>
        )}
      </FormattedMessage>
    </ul>
  )
}

const CriteriaForm = ({ history, context }) => {
  const onSubmit = e => {
    e.preventDefault()
    context.setPatientEligibility(true)
    history.push('/patients/add/step-3')
  }
  return (
    <Form onSubmit={onSubmit}>
      <Heading size={20}>Critères d'inclusion</Heading>
      <Box>
        <FormattedMessage id="eligiblePatients">
          {label => <Heading>{label}</Heading>}
        </FormattedMessage>
        {renderEligibleCriteriaFromContext(context)}
        <FormattedMessage id="nonEligiblePatients">
          {label => <Heading>{label}</Heading>}
        </FormattedMessage>
        {renderNonEligibleCriteriaFromContext(context)}
        <Checkbox
          label="patient éligible"
          name="eligiblePatient"
          id="eligiblePatient"
          defaultChecked={context.state.isEligible}
          required
        />
      </Box>
      <FormFooter previous="/patients/add/step-1" />
    </Form>
  )
}

export default props => (
  <PatientContext.Consumer>
    {context => <CriteriaForm context={context} {...props} />}
  </PatientContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/Patients/containers/CriteriaForm.js